module.exports = __webpack_public_path__ + "img/sale-path-purple.82ed29dc.png";